import { observer } from 'mobx-react';
import * as React from 'react';
import Main from '../../../BrowserSupport/Main';
import { emptyFragment } from '../../../EmptyFragment';
import Notifications from '../../../Notifications';
import I18nTitle from '../../../Title/I18nTitle';
import FlashMessage from '../../FlashMessage';
import MainNav from '../../Platform/MainNav';
import Heading from './Heading';
import ImportParticipantsState from './ImportParticipantsState';
import ImportParticipantsStore from './Store';
import ImportParticipantsReactions from './Store/Reactions';

interface Props {}

class ImportParticipants extends React.Component<Props, {}> {
  private importParticipantsStore: ImportParticipantsStore = new ImportParticipantsStore();

  componentDidMount(): void {
    this.importParticipantsStore.loading();
  }

  render() {
    return (
      <>
        <I18nTitle title="People" />
        <div className="min-h-screen">
          <MainNav />
          <Notifications />
          <div className="border-b-1 border-b-gray-200 bg-white">
            <Heading />
          </div>
          <div className="mx-auto max-w-clientPortalMaxWidth">
            <Main id="main" className="min-h-[calc(100vh-300px)]">
              {this.importParticipantsStore.notification
                .map((alert) => <FlashMessage alert={alert} />)
                .getOrElse(emptyFragment)}
              <ImportParticipantsState store={this.importParticipantsStore} />
              <ImportParticipantsReactions store={this.importParticipantsStore} />
            </Main>
          </div>
        </div>
      </>
    );
  }
}

export default observer(ImportParticipants);
